import React from 'react';
import { StyleSheet } from 'react-native';

import Box from '@components/Box/Box';

export type ChatOverlayProps = {
  visible: boolean;
  borderRadius?: string;
  backgroundColor?: string;
  children?: React.ReactNode;
  pointerEvents?: 'none' | 'auto' | 'box-none' | 'box-only';
};

const ChatOverlay: React.FC<ChatOverlayProps> = ({
  visible,
  borderRadius = 'none',
  backgroundColor = 'rgba(0, 0, 0, 0.5)',
  children,
  pointerEvents = 'auto',
}) => {
  if (!visible) return null;

  return (
    <Box
      onStartShouldSetResponder={() => true}
      pointerEvents={pointerEvents}
      style={{
        ...StyleSheet.absoluteFillObject,
        backgroundColor: backgroundColor,
        zIndex: 9999,
      }}
      borderRadius={borderRadius}>
      {children && (
        <Box
          style={{
            flex: 1,
            justifyContent: 'flex-end',
            alignItems: 'center',
          }}
          pointerEvents='box-none'>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default ChatOverlay;
